const DITypes = {
  // Socket
  SocketConnection: Symbol('AskAiSocketConnection'),
  SocketAdapter: Symbol('AskAiSocketAdapter'),
  SocketDispatcher: Symbol('AskAiSocketDispatcher'),
  SocketDispatcherFactory: Symbol('AskAiSocketDispatcherFactory'),
  SocketClient: Symbol('AskAiSocketClient'),
  // HTTP RPC
  JsonRpcDispatcher: Symbol('AskAiJsonRpcDispatcher'),
  RpcDispatcherFactory: Symbol('AskAiRpcDispatcherFactory'),
  AdapterFactory: Symbol('AskAiAdapterFactory'),
};

export default DITypes;
